<template>
  <!-- eslint-disable vue/first-attribute-linebreak, vue/max-attributes-per-line -->
  <div class="offer-policy">
    <div class="offer-policy__header">
      <div class="offer-policy__title">
        Оферта для Специалистов (лицензионный договор)
      </div>
      <div class="offer-policy__date">
        Дата публикации: <time class="offer-policy__date-value">01.09.2026</time>
      </div>
    </div>
    <ul class="offer-policy__list">
      <li class="offer-policy__item">
        <div class="offer-policy__item-title">1. Общие положения</div>
        <div class="offer-policy__item-text">
          <p class="offer-policy__item-paragraph">
            1.1. Настоящая Оферта является публичным предложением ООО «ЛИГАЛ АДС ТЕХ»
            (ОГРН 1227700103245, ИНН 9709078420, далее — Компания), адресованным
            Специалистам, заключить лицензионный договор об использовании платных
            функциональных возможностей Сервиса «Юрик.ру» на изложенных ниже условиях.
          </p>
          <p class="offer-policy__item-paragraph">
            1.2. Акцептом Оферты является любое из действий: включение Специалистом
            платного привлечения Записей в Личном кабинете, пополнение Лицевого счета либо
            иное начало использования платных функциональных возможностей Сервиса.
          </p>
          <p class="offer-policy__item-paragraph">
            1.3. Компания вправе изменять условия Оферты и Тарифы, публикуя изменения на
            Сервисе не менее чем за 5 (пять) календарных дней до вступления в силу.
            Изменения не применяются к Записям, созданным до вступления изменений в силу.
          </p>
        </div>
      </li>
      <li class="offer-policy__item">
        <div class="offer-policy__item-title">2. Предмет</div>
        <div class="offer-policy__item-text">
          <p class="offer-policy__item-paragraph">
            2.1. Компания за лицензионное вознаграждение предоставляет Специалисту право
            использования платных функциональных возможностей Сервиса: размещение
            календаря записи в Профиле (каналы «Приём в офисе» и «Онлайн-консультация»),
            получение Записей Заказчиков, получение обращений по телефону через Сервис, а
            также иные платные возможности, описанные на Сервисе.
          </p>
          <p class="offer-policy__item-paragraph">
            2.2. Вознаграждение Компании начисляется за каждую Подтвержденную Запись в
            размере, определенном Тарифами. Иные функциональные возможности Сервиса
            предоставляются безвозмездно, если Тарифами не установлено иное.
          </p>
        </div>
      </li>
      <li class="offer-policy__item">
        <div class="offer-policy__item-title">3. Тарифы</div>
        <div class="offer-policy__item-text">
          <p class="offer-policy__item-paragraph">
            3.1. Размер вознаграждения за Запись определяется Тарифами, опубликованными на
            Сервисе: для Записей на прием в офисе — по региону Специалиста; для Записей на
            онлайн-консультацию — по единому тарифу. Действующий Тариф отображается
            Специалисту в Личном кабинете до включения соответствующего канала.
          </p>
          <p class="offer-policy__item-paragraph">
            3.2. Стоимость Записи не зависит от способа ее создания (самостоятельная
            запись Заказчика, запись оператором Компании, запись по телефонному обращению
            с Профиля).
          </p>
        </div>
      </li>
      <li class="offer-policy__item">
        <div class="offer-policy__item-title">4. Лицевой счёт</div>
        <div class="offer-policy__item-text">
          <p class="offer-policy__item-paragraph">
            4.1. Расчёты осуществляются посредством Лицевого счёта Специалиста. Пополнение
            производится способами, предложенными на Сервисе (банковской картой через
            платежные сервисы; для индивидуальных предпринимателей и юридических лиц —
            также по выставленному счёту).
          </p>
          <p class="offer-policy__item-paragraph">
            4.2. Доступный остаток Лицевого счёта равен балансу за вычетом заблокированных
            сумм (п. 5.2). Специалисту доступна история операций по Лицевому счету в
            Личном кабинете.
          </p>
          <p class="offer-policy__item-paragraph">
            4.3. Платеж третьего лица в счет пополнения Лицевого счёта Специалиста
            признается платежом, совершённым уполномоченным Специалистом лицом; отношения
            с таким лицом Специалист регулирует самостоятельно.
          </p>
          <p class="offer-policy__item-paragraph">
            4.4. При расторжении договора неиспользованный остаток Лицевого счёта
            возвращается Специалисту по его письменному заявлению, направленному на
            <a class="offer-policy__item-link" href="mailto:info@jurik.ru"
              >info@jurik.ru</a
            >, в течение 10 (десяти) рабочих дней с даты получения заявления, на
            реквизиты, с которых производилось пополнение, либо на иные подтвержденные
            реквизиты Специалиста.
          </p>
        </div>
      </li>
      <li class="offer-policy__item">
        <div class="offer-policy__item-title">5. Порядок расчетов за Записи</div>
        <div class="offer-policy__item-text">
          <p class="offer-policy__item-paragraph">
            5.1. Каналы приема Записей доступны для включения и отображаются в Профиле
            только при достаточности доступного остатка Лицевого счёта для оплаты как
            минимум одной Записи по применяемому Тарифу. При недостаточности средств
            размещение календаря в Профиле приостанавливается автоматически и
            возобновляется автоматически после пополнения.
          </p>
          <p class="offer-policy__item-paragraph">
            5.2. В момент создания Записи на Лицевом счёте блокируется сумма
            вознаграждения по применяемому Тарифу (далее — Блокировка).
          </p>
          <p class="offer-policy__item-paragraph">
            5.3. Судьба Блокировки определяется исходом Записи:
          </p>
          <p class="offer-policy__item-paragraph">
            5.3.1. Специалист подтвердил Запись в Личном кабинете (либо перенёс её до
            подтверждения, что приравнивается к подтверждению на новое время) — Блокировка
            списывается в качестве вознаграждения Компании в момент подтверждения.
          </p>
          <p class="offer-policy__item-paragraph">
            5.3.2. Специалист не совершил ни одного действия с Записью в течение
            отведенного срока подтверждения (далее — Игнорирование) — Запись отменяется
            для Заказчика, а Блокировка списывается в качестве вознаграждения Компании в
            полном размере. Стороны признают, что Запись считается предоставленным
            Специалисту лидом с момента её создания: контактные данные Заказчика
            подтверждены кодом из СМС (при самостоятельной записи Заказчика) либо
            оператором Компании в ходе телефонного разговора с Заказчиком (при записи
            оператором), сведения о Записи доставлены Специалисту, и неиспользование
            Специалистом предоставленной возможности не освобождает его от оплаты. Срок
            подтверждения зависит от времени, оставшегося до консультации, отображается в
            Личном кабинете и в уведомлениях.
          </p>
          <p class="offer-policy__item-paragraph">
            5.3.3. Специалист отметил отказ («Не дозвонился» / «Заказчик отказался») —
            Запись передается на проверку Компании. Если отказ Заказчика подтвердился,
            Блокировка возвращается на Лицевой счет. Если проверкой установлено, что
            Заказчик ожидал консультацию и попыток связи с ним не предпринималось,
            Блокировка списывается как при Игнорировании.
          </p>
          <p class="offer-policy__item-paragraph">
            5.3.4. Заказчик отменил Запись до её подтверждения Специалистом — Блокировка
            возвращается.
          </p>
          <p class="offer-policy__item-paragraph">
            5.3.5. Заказчик отменил или перенёс Запись после её подтверждения, либо не
            явился на консультацию — списанное вознаграждение не возвращается:
            вознаграждение уплачивается за предоставление Подтвержденной Записи, а не за
            факт состоявшейся консультации.
          </p>
          <p class="offer-policy__item-paragraph">
            5.4. Все статусы Записи и связанные с ними операции по Лицевому счету
            отражаются в Личном кабинете Специалиста.
          </p>
          <p class="offer-policy__item-paragraph">
            5.5. Возражения по списаниям принимаются в претензионном порядке (<a
              class="offer-policy__item-link"
              href="mailto:info@jurik.ru"
              >info@jurik.ru</a
            >) в течение 3 (трёх) календарных дней с даты списания, отраженной в истории
            операций Лицевого счёта. При отсутствии возражений в указанный срок списание
            считается признанным Специалистом.
          </p>
        </div>
      </li>
      <li class="offer-policy__item">
        <div class="offer-policy__item-title">6. Обязанности Специалиста</div>
        <div class="offer-policy__item-text">
          <p class="offer-policy__item-paragraph">
            6.1. Поддерживать актуальное расписание приёма и своевременно обрабатывать
            Записи: подтверждать, переносить либо отмечать отказ до истечения срока
            подтверждения.
          </p>
          <p class="offer-policy__item-paragraph">
            6.2. Проводить консультации по Подтвержденным Записям лично (для Юристов и
            Адвокатов) в согласованные дату, время и формате.
          </p>
          <p class="offer-policy__item-paragraph">
            6.3. Использовать контактные данные Заказчиков исключительно для исполнения их
            обращений.
          </p>
          <p class="offer-policy__item-paragraph">
            6.4. Не склонять Заказчиков, обратившихся через Сервис, к взаимодействию в
            обход Сервиса.
          </p>
        </div>
      </li>
      <li class="offer-policy__item">
        <div class="offer-policy__item-title">7. Материалы Специалиста</div>
        <div class="offer-policy__item-text">
          <p class="offer-policy__item-paragraph">
            7.1. Статьи и иные материалы, публикуемые Специалистом в журнале (блоге)
            Сервиса, предоставляются Компании на безвозмездной основе: Специалист
            предоставляет Компании безвозмездную простую неисключительную лицензию на их
            использование любыми способами без ограничения срока и территории.
            Опубликованные материалы остаются на Сервисе и могут использоваться Компанией,
            в том числе после расторжения договора и удаления Профиля; за Специалистом
            сохраняется право авторства.
          </p>
          <p class="offer-policy__item-paragraph">
            7.2. Специалист гарантирует, что обладает правами на публикуемые материалы и
            что их публикация не нарушает прав третьих лиц.
          </p>
        </div>
      </li>
      <li class="offer-policy__item">
        <div class="offer-policy__item-title">8. Права Компании</div>
        <div class="offer-policy__item-text">
          <p class="offer-policy__item-paragraph">
            8.1. Компания вправе приостановить размещение календаря Специалиста в Профиле
            при недостаточности средств на Лицевом счёте, отзыве верификации, а также при
            систематическом Игнорировании Записей или систематических жалобах Заказчиков.
          </p>
          <p class="offer-policy__item-paragraph">
            8.2. Компания вправе связываться со Специалистом и Заказчиками для проверки
            исходов Записей; телефонные разговоры могут записываться с уведомлением в
            установленном законом порядке.
          </p>
        </div>
      </li>
      <li class="offer-policy__item">
        <div class="offer-policy__item-title">9. Заключительные положения</div>
        <div class="offer-policy__item-text">
          <p class="offer-policy__item-paragraph">
            9.1. Договор действует с момента акцепта неопределённый срок. Каждая сторона
            вправе отказаться от договора, уведомив другую сторону; при этом обязательства
            по созданным до расторжения Записям сохраняются, а остаток Лицевого счёта
            возвращается в порядке п. 4.4.
          </p>
          <p class="offer-policy__item-paragraph">
            9.2. Претензионный порядок обязателен; срок ответа на претензию — 14
            (четырнадцать) календарных дней. Споры, подведомственные арбитражному суду,
            рассматриваются в Арбитражном суде города Москвы; иные споры — в суде общей
            юрисдикции по месту нахождения Компании.
          </p>
          <p class="offer-policy__item-paragraph">
            9.3. Во всём, что не урегулировано Офертой, применяются Пользовательское
            соглашение и законодательство Российской Федерации.
          </p>
          <p class="offer-policy__item-paragraph">
            9.4. Контакты Компании: ООО «ЛИГАЛ АДС ТЕХ», ОГРН 1227700103245, ИНН
            9709078420, e-mail:
            <a class="offer-policy__item-link" href="mailto:info@jurik.ru"
              >info@jurik.ru</a
            >.
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>

<style lang="less">
.offer-policy {
  .flex-column(@size-x10);

  &__header {
    .flex-column(@size-x3);
  }

  &__title {
    .h-offset-reset();

    font-size: @size-x8;
    font-weight: 700;
    line-height: 130%;
  }

  &__date {
    font-size: @size-x4;
    font-weight: 400;
    line-height: 130%;
    color: @color-dove-gray;
  }

  &__list {
    .flex-column(@size-x10);

    max-width: 997px;
  }

  &__item {
    .flex-column(@size-x6);
  }

  &__item-title {
    .h-offset-reset();

    font-size: @size-x6;
    font-weight: 700;
    line-height: 130%;
  }

  &__item-text {
    .flex-column(@size-x4);
  }

  &__item-paragraph {
    .p-offset-reset();

    font-size: @size-x4;
    font-weight: 400;
    line-height: 130%;
  }

  &__item-link {
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
}
</style>
